module.exports = __webpack_public_path__ + "img/L_TH.2e19b6a4.png";